export default __webpack_public_path__ + "static/Prostatizal-tablet-4001e0a1bf241f1805780b309804040c.jpg";